<template>
  <ul class="a-checklist">
    <li v-for="item in items" :key="item.text" class="a-checklist-item">{{ $t(item.text) }}</li>
  </ul>
</template>

<script>
export default {
  props: {
    items: {}
  }
}
</script>

<style lang="scss">
@import '../../utilities/config';

.a-checklist {
  list-style: none;
  padding-left: 1.5rem;

  &-item {
    position: relative;
    color: gray('gray-700');
    margin-bottom: 0.5rem;

    &::before {
      background-image: url(../../assets/check_green.svg);
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
      content: '';
      display: block;
      position: absolute;
      top: -1px;
      left: 0;
      width: 1rem;
      height: 1.5rem;
      margin-left: -1.5rem;
    }
  }
}
</style>
